// Template.Ref — version-level reference to a Template.
export { mk };
const mk = (id, version) => ({
    type: "template_ref",
    id,
    version,
});
//# sourceMappingURL=ref.js.map